module.exports = __webpack_public_path__ + "static/level-8-logo.e0eeb10d.png";